import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHTwentyFiveResult',
    name: 'PageOneHTwentyFiveResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHTwentyFive/result.vue'),
  },
  {
    path: '/IFPageOneHTwentyFiveGuide',
    name: 'PageOneHTwentyFiveGuide',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHTwentyFive/guide.vue'),
  },
];
